<div>
  <loading-spinner [isLoading]="isPending" [classesString]="'top-50'"></loading-spinner>
  <div [ngClass]="{ 'd-none': isNoDataForChart }">
    <canvas
      #chartElement
      [id]="chartId"
      class="chart w-100 h-auto"
      [width]="chartCanvasWidth"
      [height]="chartCanvasHeight"
    ></canvas>
  </div>
  @if (isNoDataForChart) {
    <div class="text-center m-3">{{ 'chart.noDataFor' | translate }} {{ type | translate }}</div>
  }
</div>
